import { createContext, useContext, useState } from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Page.module.css";

type PageContextType = {
  menuPanel: boolean;
  sidePanel: boolean;
  contentPanel: boolean;
  headerPanel: boolean;
  footerPanel: boolean;
  mainPanel: boolean;
};

const PageContext = createContext<[PageContextType, React.Dispatch<React.SetStateAction<PageContextType>>]>([
  {
    menuPanel: false,
    sidePanel: false,
    contentPanel: false,
    headerPanel: false,
    footerPanel: false,
    mainPanel: false,
  },
  () => null,
]);

export const useStore = () => useContext(PageContext);

type PageProps = {
  className?: string;
  children?: React.ReactNode;
};

const Page: React.FC<PageProps> = ({ className, children }) => {
  return (
    <PageContext.Provider
      value={useState<PageContextType>({
        menuPanel: false,
        sidePanel: false,
        contentPanel: false,
        headerPanel: false,
        footerPanel: false,
        mainPanel: false,
      })}
    >
      <div className={cls(styles.page, className)}>{children}</div>
    </PageContext.Provider>
  );
};

export default Page;
